import { render, staticRenderFns } from "./new-resource-action.vue?vue&type=template&id=14fbac56&scoped=true"
import script from "./new-resource-action.vue?vue&type=script&lang=js"
export * from "./new-resource-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fbac56",
  null
  
)

export default component.exports